import axios from 'axios/index';
import { request_mutations, request_state } from '../utils/store';
import {
    USERS_LIST, USER_UPDATE, USER_CHANGE_PASSWORD, SIGNOUT,
} from '../api';
import { auth } from '../utils/requests';
import { copy } from '../utils/helpers';

const user_init_state = {
    id: null,
    photo: null,
    email: null,
    company: null,
    last_name: null,
    first_name: null,
};

export default {
    namespaced: true,
    state: {
        token: null,
        user: copy(user_init_state),
        list: request_state(),
        sign_out: request_state(),
        update: request_state(),
        change_password: request_state(),
        upload_avatar: request_state(),
    },
    mutations: {
        ...request_mutations('users_list', 'list'),
        ...request_mutations('sign_out', 'sign_out'),
        ...request_mutations('update', 'update'),
        ...request_mutations('upload_avatar', 'upload_avatar'),
        ...request_mutations('change_password', 'change_password'),
        reset_user(state) {
            state.token = null;
            state.user = copy(user_init_state);
        },
        set_user(state, user) {
            state.user = user;
        },
        set_token(state, token) {
            state.token = token;
        },
        clean_update(state) {
            state.update = request_state();
        },
        clean_change_password(state) {
            state.change_password = request_state();
        },
    },
    actions: {
        list({ commit }, params) {
            commit('users_list_loading');
            axios.get(USERS_LIST, { params, ...auth() })
                .then(response => commit('users_list_success', response.data))
                .catch(error => commit('users_list_error', error.response ? error.response.data : {}));
        },
        sign_out({ commit }, params) {
            commit('sign_out_loading');
            return new Promise((resolve) => {
                axios.get(SIGNOUT, { params, ...auth() }).then((response) => {
                    commit('sign_out_success', response.data);
                    commit('reset_user', response.data);
                    resolve();
                });
            });
        },
        update({ commit }, data) {
            commit('update_loading');
            axios.patch(USER_UPDATE, data, auth()).then((response) => {
                commit('update_success', response.data);
                commit('set_user', response.data);
            }).catch(error => commit('update_error', error.response ? error.response.data : {}));
        },
        upload_avatar({ commit }, file) {
            const form = new FormData();
            form.append('photo', file);

            commit('upload_avatar_loading');
            axios.patch(USER_UPDATE, form, auth()).then((response) => {
                commit('upload_avatar_success', response.data);
                commit('set_user', response.data);
            }).catch(error => commit('upload_avatar_error', error.response ? error.response.data : {}));
        },
        change_password({ commit }, data) {
            commit('change_password_loading');
            axios.put(USER_CHANGE_PASSWORD, data, auth()).then((response) => {
                commit('change_password_success', response.data);
            }).catch(error => commit('change_password_error', error.response ? error.response.data : {}));
        },
    },
};
